export const Roles = {
    user: 'USER',
    admin: 'ADMIN',
    manager: 'MANAGER',
    scanner: 'SCANNER',
    system: 'SYSTEM',
    superAdmin: 'SUPER_ADMIN',
} as const;

export type Role = typeof Roles[keyof typeof Roles];
